<template>
  <state
    state="success"
    :heading="heading"
    :message="description"
    :link="redirectUri"
    :linkText="computedLinkText"
  />
</template>

<script>
import State from '@/components/layout/State.vue';

export default {
  components: { State },
  props: {
    message: {
      default: '',
    },
    link: {
      default: '/',
    },
    linkText: {
      default: 'GO_TO_MAIN_PAGE',
    },
  },
  computed: {
    title() {
      return this.$t('OK');
    },
    heading() {
      return this.$route.query.title || '';
    },
    description() {
      return this.$route.query.description || this.message || undefined;
    },
    redirectUri() {
      const explicitLink = this.$route.query.redirect_uri || this.link;
      if (explicitLink) {
        return explicitLink;
      }

      if (this.hasQuery) {
        return '/';
      }

      return undefined;
    },
    redirectTimeout() {
      return this.$route.query.redirect_timeout;
    },
    computedLinkText() {
      if (this.redirectUri) {
        return 'CONTINUE';
      }

      if (this.hasQuery) {
        return 'GO_TO_MAIN_PAGE';
      }

      if (this.linkText) {
        return this.linkText;
      }

      return undefined;
    },
    hasQuery() {
      return this.$route.query.title || this.$route.query.description;
    },
  },
  created() {
    if (this.redirectTimeout && this.redirectUri) {
      setTimeout(() => {
        this.$router.push(this.redirectUri);
      }, this.redirectTimeout * 1000);
    }
  },
};
</script>
